import styles from './informacaoBasica.module.scss';
function InformacaoBasica({ titulo, conteudo }: { titulo: string; conteudo: string }) {
  return (
    <>
      {!!conteudo && (
        <div className={styles.item} tabIndex={0} aria-label={`${titulo}: ${conteudo}`}>
          <strong> {titulo} </strong>
          <p> {conteudo} </p>
        </div>
      )}
    </>
  );
}

export default InformacaoBasica;
